import React from "react";
import { ENVIRONMENT, ENVIRONMENT_COLOR } from "../../constants/api.constants";

export const EnvironmentInfo = () => {
  if (ENVIRONMENT || ENVIRONMENT != null) {
    return (
      <h2>
        <span className="badge badge-dark environment__Info rounded border border-primary">
          {ENVIRONMENT}
        </span>
      </h2>
    );
  } else {
    return null;
  }
};

export const EnvironmentColor = () => {
  if (ENVIRONMENT_COLOR && ENVIRONMENT_COLOR != null) {
    const bgColor = {
      backgroundColor: ENVIRONMENT_COLOR
    };
    return bgColor;
  } else {
    return null;
  }
};
